export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"

export const EMAIL_VERIFICATION = "EMAIL_VERIFICATION"
export const EMAIL_VERIFICATION_SUCCESSFUL = "EMAIL_VERIFICATION_SUCCESSFUL"
export const EMAIL_VERIFICATION_FAILED = "EMAIL_VERIFICATION_FAILED"
